import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faLinkedin,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-grid">
        {/* Brand Section */}
        <div className="footer-brand">
          <img
            src="/CuttechSolLogo.png"
            alt="CUTTECH Logo"
            className="footer-logo"
          />

          <h2 className="brand-name">CUTTECH Solutions</h2>

          <p>
            Precision cutting tool solutions for automotive, aerospace, and
            general engineering industries.
          </p>

          {/* Address */}
          <address>
            CUTTECH SOLUTIONS,
            <br />
            Research and Development Unit Sathyojatha Arcade, 45/458,
            Srigandhada Kaval, Health Layout,
            <br />
            Sunkadakatte, Bengaluru, Karnataka - 560091
            <br />

            <a
              href="https://maps.app.goo.gl/MgA3wWvvvEHFp1449?g_st=aw"
              target="_blank"
              rel="noreferrer"
              className="address-link"
            >
              📍 View on Google Maps
            </a>
          </address>

          {/* GST */}
          <p>
            <strong>GST IN:</strong> 29AAWFC5220A1ZK
          </p>

          {/* Email */}
          <p>
            <strong>Email:</strong>{" "}
            <a
              href="mailto:sales@cuttech.solutions"
              className="contact-link"
            >
              sales@cuttech.solutions
            </a>
          </p>

          {/* Phone */}
          <p>
            <strong>Phone:</strong>{" "}
            <a href="tel:+918023286380" className="contact-link">
              080-23286380
            </a>{" "}
            /{" "}
            <a href="tel:+917019444941" className="contact-link">
              +91 7019444941
            </a>
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <h3>Quick Links</h3>

          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>

            <li>
              <Link to="/products">Products</Link>
            </li>

            <li>
              <Link to="/about">About</Link>
            </li>

            <li>
              <Link to="/contact">Contact</Link>
            </li>

            <li>
              <Link to="/terms">Terms & Conditions</Link>
            </li>

            <li>
              <Link to="/privacy">Privacy Policy</Link>
            </li>

            <li>
              <Link to="/faqs">FAQs</Link>
            </li>
          </ul>
        </div>

        {/* Social Media */}
        <div className="footer-social">
          <h3>Follow Us</h3>

          <div className="social-icons">
            <a
              href="https://www.facebook.com/share/1JXwRfrWC2/"
              target="_blank"
              rel="noreferrer"
              className="icon facebook"
            >
              <FontAwesomeIcon icon={faFacebookF} />
            </a>

            <a
              href="https://www.instagram.com/cuttechsolutions?igsh=MTVmNTU5OWZycjk5cg=="
              target="_blank"
              rel="noreferrer"
              className="icon instagram"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>

            <a
              href="https://www.linkedin.com/company/cuttech-solutions/"
              target="_blank"
              rel="noreferrer"
              className="icon linkedin"
            >
              <FontAwesomeIcon icon={faLinkedin} />
            </a>

            <a
              href="https://youtube.com/@simplemechanicalsolutions?si=Uizp9MkFTFZKuLas"
              target="_blank"
              rel="noreferrer"
              className="icon youtube"
            >
              <FontAwesomeIcon icon={faYoutube} />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} CUTTECH Solutions. All rights
        reserved.
      </div>
    </footer>
  );
};

export default Footer;